import * as angular from "angular";
import * as _ from "lodash";
import { User } from "./user.model";

export class ActivityFilter {
    public uids: any = { values: [], selectedUsers: [], checked: false };
    public canvass_type = { values: [], checked: false };
    public reception = { values: [], checked: false };
    public surveyed = { values: [], checked: false };
    public queried = { values: [], checked: false };
    public exact_date = { values: [], checked: false };
    public start_date = { values: [], checked: false };
    public end_date = { values: [], checked: false };
    public types = { values: [], checked: false };

    constructor(data?: object, user?: User) {
        if (data) {
            this.setData(data);
        } else if (user) {
            this.uids.values.push(user);
            this.uids.checked = true;
        }
    }

    setData(data: object): void {
        angular.forEach(this, (filterItem) => {
            if (filterItem && filterItem.values) {
                filterItem.values = [];
            }
        });
        _.merge(this, data);
    }

    nonEmptyValues(): object {
        let nonEmptyFilters: any = {};

        for (let key in this) {
            const value = (this as any)[key];
            if (
                value &&
                (value.checked || angular.isUndefined(value.checked))
            ) {
                if (
                    typeof value !== "function" &&
                    this.hasOwnProperty(key) &&
                    angular.isDefined(value.values) &&
                    (value.values.length ||
                        (value.selectedUsers && value.selectedUsers.length))
                ) {
                    if (value.values && value.values.length) {
                        nonEmptyFilters[key] = value.values;
                    } else if (
                        value.selectedUsers &&
                        value.selectedUsers.length
                    ) {
                        nonEmptyFilters[key] = value.selectedUsers.map(
                            (user) => user.uid
                        );
                    }
                }
            }
        }

        return nonEmptyFilters;
    }
}
